/* ============================================================
   CART DRAWER CONTROLLER (Horizon Theme)

   Responsibilities:
   - Open / close cart drawer
   - React to add-to-cart
   - React to cart refresh events (UI only)

   IMPORTANT:
   - NO surcharge logic here
   - NO cart mutation here
   ============================================================ */

import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {

  connectedCallback() {
    super.connectedCallback();

    // Open drawer when product is added
    document.addEventListener(
      CartAddEvent.eventName,
      this.#handleCartAdd
    );

    // Horizon internal refresh hook (UI sync only)
    document.addEventListener(
      "cart:refresh",
      this.#handleCartRefresh
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(
      CartAddEvent.eventName,
      this.#handleCartAdd
    );

    document.removeEventListener(
      "cart:refresh",
      this.#handleCartRefresh
    );
  }

  /* ------------------------------------------------
     Open drawer automatically after Add to Cart
  ------------------------------------------------ */
  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  /* ------------------------------------------------
     Handle cart refresh (UI ONLY)
     ❌ No cart changes here
     ❌ No surcharge logic
  ------------------------------------------------ */
  #handleCartRefresh = () => {
    // Intentionally empty.
    // This keeps Horizon drawer lifecycle stable.
  };

  /* ------------------------------------------------
     Public open / close helpers
  ------------------------------------------------ */
  open() {
    this.showDialog();

    // Close drawer if payment terms CTA is clicked
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const shadowRoot =
        document.querySelector('shopify-payment-terms')?.shadowRoot;

      const cta =
        shadowRoot?.querySelector('#shopify-installments-cta');

      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

/* ------------------------------------------------
   Register web component
------------------------------------------------ */
if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
